import React, { useEffect } from "react";
import style from './CustomFalseCeiling.module.scss';

const CustomTextareaView = (props: any) => {
  const { details, index, isDrawingsExporting, updateDetails, itemDetails } = props;
  

  useEffect(() => {
    details?.options?.map((e: any, i: any) => {
      const textarea:any = document.getElementById(`inputTextArea_${e?.id}`);
      if(textarea) {
        textarea.style.height = ""; // Reset the height to default
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    })
  }, [])

  const handleChange = (event, id) => {
    const textarea:any = document.getElementById(`inputTextArea_${id}`);
    if(textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 150) + 'px';
      textarea.value = textarea.value.split('\n').slice(0, 3).join('\n').replace(/\s{2,}/g, ' ');
      textarea.style.overflowY = (textarea.scrollHeight >= 150) ? 'scroll' : 'auto';
  
      updateDetails({ id: id, value: textarea.value })
    }
  }

  return (
    <div key={index}>
      <div className={style.sub_tab_section}>
        <h4 className="sub_tab_heading">
          {details?.label}
        </h4>
        <div className={style.sub_tab_options}>
          {
            details?.options?.map((e: any, i: any) => (
              <div className={style.sub_value_tab} key={i}>
                {e.label ? <p className={style.sub_label}>{e.label}</p> : ''}
                <div className={style.sub_value}>
                  {
                    !isDrawingsExporting ? <textarea id={"inputTextArea_"+ e.id} value={itemDetails?.[e.id] || ''} onChange={(v) => handleChange(v, e.id)} maxLength={100} />
                      : <p>{itemDetails?.[e.id] || '-'}</p>
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default CustomTextareaView;